import { useQuery } from 'react-query';
import { useLocale } from '../../../../../../i18n';
import { wgApi } from '../../../../../app/src/features/api/wgApi';
import { InsuranceProductsResp } from '../../../../../settings/src/features/risk-domains/types/InsuranceProducts';

export interface UseGetInsuranceProductsProps {
  riskObjectId?: string;
  q?: string;
  recommendationId?: string;
  lang?: string;
}

export const getUseInsuranceProductsByRiskObjectQKey = (
  riskObjectId?: string,
  q?: string,
  recommendationId?: string,
  lang?: string,
) => ['insurance-products', riskObjectId, q, recommendationId, lang];

const getInsuranceProductsByRiskObject = async ({
  userCountry,
  lang,
  riskObjectId,
  q,
  recommendationId,
}: UseGetInsuranceProductsProps & {
  userCountry: string;
  lang: string;
}): Promise<InsuranceProductsResp> => {
  const { data, isError } = await wgApi.get<InsuranceProductsResp>(
    `v1/api/risk_objects/${riskObjectId}/possible-insurance-products`,
    {
      query: {
        country: userCountry,
        lang: lang,
        pagelen: 999,
        q,
        recommendation_id: recommendationId,
      },
    },
  );
  if (isError) throw new Error();
  return data;
};

export const useInsuranceProductsByRiskObject = ({
  riskObjectId,
  q,
  recommendationId,
  lang,
}: UseGetInsuranceProductsProps) => {
  const { userCountry, userLang } = useLocale();

  return useQuery(
    getUseInsuranceProductsByRiskObjectQKey(riskObjectId, q, recommendationId),
    () =>
      getInsuranceProductsByRiskObject({
        userCountry,
        lang: lang || userLang,
        riskObjectId,
        q,
        recommendationId,
      }),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      enabled: !!riskObjectId,
    },
  );
};
